import { getInstance } from './index'

function allowedRoute (route, auth) {
  if ('roles' in auth && auth.roles.includes('superadmin')) {
    return true
  }
  return false
}

export const authGuard = (to, from, next) => {
  const authService = getInstance()

  const getTargetUrl = () => {
    const targetUrl = localStorage.getItem('targetUrl')
    return targetUrl && targetUrl !== 'undefined' ? targetUrl : to.fullPath
  }

  const fn = () => {
    // If the user is authenticated, continue with the route
    if (authService.isAuthenticated) {
      const authUser = authService.user['https://starlightintel.com/roles']
      if (allowedRoute(to, authUser)) {
        localStorage.removeItem('targetUrl')
        return next()
      } else {
        // AuthorizationFailed.vue will set up the targetUrl
        return next({ path: '/authorization-failed', query: { targetUrl: getTargetUrl() } })
      }
    }

    // Otherwise, log in
    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } })
  }

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    return fn()
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch('loading', loading => {
    if (loading === false) {
      return fn()
    }
  })
}
